import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {Range} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/Range/Range';
import {useImageRotate} from '~/CreateFabricInvitation/components/PhotoEditor/common/useImageRotate';

export const RotateControl = ({canvas, processing}) => {
  const {rotationValue, handleRotationChange} = useImageRotate(canvas);

  return (
    <div className="uyo-control-slider-container">
      <Typography variant="list1" classNames="uyo-control-slider-label">
        Rotate
      </Typography>
      <div className="uyo-control-slider">
        <Range
          min={-180}
          max={180}
          step={30}
          value={rotationValue}
          onChange={handleRotationChange}
          onLocalChange={handleRotationChange}
          hasControls
          hiddenInput
          dataQaId="rotate-slider"
          disabled={processing}
        />
      </div>
    </div>
  );
};
